<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!-- <h3 class="insurance-green">這裡是標題</h3> -->
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
        </div>
        <div class="modal-body">
          <table class="table insurance-green">
            <thead>
  
            </thead>
            <tbody>
              <tr v-if="inputs.handle === '取消'">
                <th style="width:200px;">拒絕/取消原因</th>
                <td>
                  <ul>
                    <li v-for="(item, i) in inputs.codedesc" :key="`claim-data-${i}`">{{item.CODEDESC}}</li>
                  </ul>
                </td>
              </tr>
              <tr v-if="inputs.handle === '補件'">
                <th style="width:200px;">補件原因</th>
                <td>
                  <ul>
                    <li v-for="(item, i) in inputs.codedesc" :key="`claim-data-${i}`">{{item.CODEDESC}}</li>
                  </ul>
                </td>
              </tr>
              <tr v-if="inputs.handle === '補件'">
                <th>補件注意事項</th>
                <td>
                  <ul>
                    <li>如對補件內容有問題，請於上班時間致電國泰世華銀行國壽同仁專線：(02)2191-1017。</li>
                    <li>非親簽類文件或可傳真文件(如財力證明、職業、電話地址、電子票證同意書)：
                      <ul>
                        <li>建議以iPad或手機至【國泰世華官網首頁＞線上補件】拍照上傳，提升補件效率加速審理作業。</li>
                        <li>傳真補件：(02)7747-2060。傳真後查詢電話：(02)8722-6488 #7412。</li>
                      </ul>
                    </li>
                    <li>親簽類文件(申請書、法代同意書)、照片：請送至服務中心，或自行郵寄至銀行，郵寄地址：10563台北市松山區光復南路35號1樓「國泰世華銀行 信用卡作業部」收。</li>
                  </ul>
                </td>
              </tr>
              <tr v-if="inputs.handle === '補件'">
                <th>其他注意事項</th>
                <td>
                  <ul>
                    <li>如補件原因為「補簽呈/公文文號」，請洽整合行銷科。</li>
                    <li>身分證影本請使用國泰世華官網線上補件拍照上傳，避免因傳真影像模糊，導致再次補件。</li>
                    <li>傳真補件資料請務必註明「國壽補件」及客戶身分證號碼、姓名、推薦人姓名、手機號碼，以利銀行補件資料的處理。</li>
                    <li>持中華民國身分證申辦者，申請書上的簽名請務必用「中文正楷」簽名；外籍人士申請書上的簽名則需與護照上相同。</li>
                    <li>新申辦客戶經常漏填職業資料欄位(公司電話、地址)、帳單寄送地之勾選等，送件前請確實檢查；如客戶為家管、自由業、退休人士等，也需註明清楚，不可空白。</li>
                    <li>學生辦卡、外籍人士辦卡有特殊規範，記得先到「金控入口網站\行銷支援\整合行銷與放款\整合行銷專區\信用卡\業務介紹」查閱。</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>       
        </div>
        <div class="modal-footer">
          <div class="action text-right">
            <a  @click="$emit('close')" class="btn btn-default">
              確定
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MarketingDataModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    inputs: {
      type: Object,
      default: () => {
        return null
      },
    }
  },
  data () {
    return {
      form: {
        
      }
    }
  },
  methods: {

  },
  mounted () {
  }
}
</script>

<style scoped>
.table li {
  margin: 5px 0;
  line-height: 25px;
}
</style>
